import { useEffect, useState } from 'react'
import { KTIcon } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { truncateText } from '../../../../reusable'

/* eslint-disable jsx-a11y/anchor-is-valid */

const AsideToolbar = () => {
  const [userData, setuserData] = useState(Object)


  useEffect(() => {
    var tmp: any = sessionStorage.getItem("admin")
    tmp = JSON.parse(tmp)
    setuserData(tmp)


  }, []);

  return (
    <>
      {/*begin::User*/}
      <div className='aside-user d-flex align-items-sm-center justify-content-center py-5'>
        {/*begin::Symbol*/}
        <div className='symbol symbol-50px'>
          <img src={userData.profilePicture} alt='' />
        </div>
        {/*end::Symbol*/}

        {/*begin::Wrapper*/}
        <div className='aside-user-info flex-row-fluid flex-wrap ms-5'>
          {/*begin::Section*/}
          <div className='d-flex'>
            {/*begin::Info*/}
            <div className='flex-grow-1 me-2'>
              {/*begin::Username*/}
              <a href='#' className='text-dark fs-6 fw-bold'>
                {userData.fullName}
              </a>
              {/*end::Username*/}

              {/*begin::Description*/}
              <span className='text-gray-600 fw-bold d-block fs-8 mb-1'>{userData.email && truncateText(userData.email, 18)}</span>
              {/*end::Description*/}
            </div>
            {/*end::Info*/}

            {/*begin::User menu*/}
            <div className='me-n2'>
              {/*begin::Action*/}
              <a
                href='#'
                className='btn btn-icon btn-sm btn-active-color-primary mt-n2'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-start'
                data-kt-menu-overflow='false'
                data-kt-menu-target='#kt_header_user_menu'

              >
                <KTIcon iconName='setting-2' className='text-muted fs-1' />
              </a>

              <HeaderUserMenu />

            </div>
            {/*end::User menu*/}
          </div>
          {/*end::Section*/}
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::User*/}

      {/*begin::Aside search*/}

      {/*end::Aside search*/}
    </>
  )
}

export { AsideToolbar }
